import { AxiosResponse } from 'axios';

/**
 * Response Interceptor: Normalizes the response before passing it to the caller.
 */
export const onResponse = (response: AxiosResponse): any => {
    // Normalize successful responses: Return only response.data
    // This prevents Axios response objects from leaking upward to the domain/presentation layer.
    return response.data;
};
